import type {
  UserResponse,
  LoginResponse,
  EmailVerificationResponse,
} from '@@/types/api';
import { useApi } from './use-api';

export function useAuthApi() {
  const { get, post } = useApi('');

  return {
    login: (body: { email: string; password: string }) =>
      post<LoginResponse>('/api/v1/auth/login', { body }),
    exchangeCode: (body: { code: string }) =>
      post<LoginResponse>('/api/v1/auth/exchange-code', { body }),
    fetchCurrentUser: () => get<UserResponse>('/api/v1/user/profile'),

    // --- Email verification OTP (user-account endpoints, not per-product) ---
    // Both are `success`-flagged: an HTTP 200 can still carry a business
    // failure. See `EmailVerificationResponse`. Both are also rate limited
    // (`otp-send` / `otp-verify`), so a 429 ApiError is an expected outcome.
    sendEmailVerificationCode: () =>
      post<EmailVerificationResponse>('/api/v1/user/email/verification-code'),
    verifyEmailCode: (body: { code: string }) =>
      post<EmailVerificationResponse>('/api/v1/user/email/verify-code', {
        body,
      }),
  };
}
